<template>
  <footer>
    <div class="cont">
      <div class="footerTop flex">
        <div class="flexItem"> 
          <b>关于我们</b>
          <router-link to="/about?m=intro" target="_blank">平台介绍</router-link>
          <router-link to="/about?m=contact" target="_blank">联系我们</router-link>
        </div>
        <div class="flexItem">
          <b>课程类别</b>
          <router-link :to="{ path: '/course', query: { c: '师德修养' } }">师德修养</router-link>
          <router-link :to="{ path: '/course', query: { c: '学科教学' } }">学科教学</router-link>
          <router-link :to="{ path: '/course', query: { c: '班级管理' } }">班级管理</router-link>
          <router-link :to="{ path: '/course', query: { c: '学习与发展' } }">学习与发展</router-link>
        </div>
        <div class="flexItem">
          <b>法律信息</b>
          <router-link to="/about?m=agreement" target="_blank">用户协议</router-link>
          <router-link to="/about?m=privacy" target="_blank">隐私政策</router-link>
          <router-link to="/about?m=declare" target="_blank">免责声明</router-link>
        </div>
        <div class="flexItem">
          <b>友情链接</b>
          <a href="http://www.moe.gov.cn/" target="_blank">教育部</a>
          <a href="http://edu.qingdao.gov.cn/" target="_blank">青岛教育局</a>
          <a href="http://jsjy.qdedu.net/login" target="_blank">继续教育平台</a>
        </div>
        <div class="flexItem">
          <img src="../../assets/qr_code.png" class="QRcode" />
          <span class="QRtext">微信扫一扫关注</span>
        </div>
        <div class="flexItem">
          <img src="../../assets/ke_fu_tel.png" class="telIcon" />
          <span class="telText">24小时客服电话</span>
          <span class="telNumber">0532-82870000</span>
        </div>
      </div>
      <div class="footerBottom">
        <span class="left">© 2022 青岛新闻网络传播有限公司</span>
        <span class="right">公安部备案: 37020202000008 工信部备案: 鲁B2-20051014</span>
      </div>
    </div>
  </footer>
</template>

<style scoped>
footer {
  background-color: #f9f9f9;
  width: 100%;
  min-width: 1200px;
  height: 482px;
  position: relative;
}

footer.index {
  background-color: #fff
}

footer .cont {
  width: 1200px;
  margin: 0 auto;
}

footer .cont .footerTop {
  height: 302px;
  border-bottom: 1px solid #EBEBEB;
  padding-top: 60px;
  align-items: flex-start;
}

footer .cont .footerTop b {
  color: #151515;
  font-size: 18px;
  font-weight: bold;
  display: block;
  margin-bottom: 16px;
}

footer .cont .footerTop a {
  display: block;
  color: #151515;
  font-size: 14px;
  line-height: 32px;
}

footer .cont .footerTop a:hover {
  color: var(--link-hover-color)
}

footer .cont .QRcode {
  display: block;
  width: 100px;
  height: 100px;
  margin-bottom: 16px;
}

footer .cont .QRtext {
  color: #707070;
  font-size: 14px;
  text-align: center;
  display: block;
  width: 100px;
}

footer .cont .telIcon {
  display: block;
  margin: 0 auto;
  width: 54px;
  height: 46px;
  margin-bottom: 9px;
}

footer .cont .telText {
  display: block;
  text-align: center;
  color: #707070;
  font-size: 12px;
  margin-bottom: 10px;
}

footer .cont .telNumber {
  display: block;
  text-align: center;
  color: #003399;
  font-size: 20px;
}

footer .cont .footerBottom {
  margin-top: 30px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}

footer .cont .footerBottom .left {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  min-width: 0;
  text-align: left;
  color: #707070;
  font-size: 14px;
}

footer .cont .footerBottom .right {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  min-width: 0;
  text-align: right;
  color: #707070;
  font-size: 14px;
}
</style>